export default [
  // {
  //   path: '/',
  //   name: '首页',
  //   component: () => import('@/views/dealhome/goodsList.vue')
  // },
  {
    path: 'shopIndex',
    name: '店铺',
    component: () => import('@/views/dealhome/shopIndex.vue')
  },
  {
    path: 'goodsDetails',
    name: '详情页',
    component: () => import('@/views/dealhome/goodsDetails.vue')
  },
  {
    path: 'standard',
    name: '标准',
    component: () => import('@/views/standard/standard.vue')
  },
  {
    path: 'bzcx',
    name: '标准查询',
    component: () => import('@/views/standard/bzcx.vue')
  },
  {
    path: 'xlcx',
    name: '限量查询',
    component: () => import('@/views/standard/xlcx.vue')
  },
    {
    path: 'StandardService',
    name: '标准服务',
    component: () => import('@/views/StandardService/StandardService.vue')
  },
      {
    path: 'Standardfranchise',
    name: '检测机构入驻',
    component: () => import('@/views/StandardService/Standardfranchise.vue')
  },
    {
    path: 'StandardJcbg',
    name: '检测报告查询',
    component: () => import('@/views/StandardService/StandardJcbg.vue')
  },
  {
    path: 'testOrganization',
    name: '检测机构查询',
    component: () => import('@/views/StandardService/testOrganization.vue')
  },
  {
    path: 'mapService',
    name: '检测服务地图',
    component: () => import('@/views/StandardService/mapService.vue')
  },
]